/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preferences/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Account from './Account/index'
import Doctor from './Doctor/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Preferences({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/Connection/Content/SetupAutomations/Content/Content/ActiveStep/Preferences"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 size="large"
 text="The following settings will be used whenever an iTero scan request is made. This will be used on patient check-in or whenever someone manually requests an iTero scan from Images."
/>
<Account
  viewPath={`${viewPath}/Account`}
/>
<Doctor
  viewPath={`${viewPath}/Doctor`}
/>
{children}
</React.Fragment>)
}